import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { RelatorioEntradasSaidasClienteRequest } from '../../requests/financas/relatorio-entradas-saidas-cliente.request';
import { SaveRelatorioFiltroFavoritoRequest } from '../../requests/financas/save-relatorio-filtro-favorito.request';
import { SaveRelatorioFiltroFavoritoResponse } from '../../responses/financas/relatorio-filtro-favorito.response';
import {
    RelatorioEntradasSaidasClienteLookupResponse,
    RelatorioEntradasSaidasClienteResponse
} from '../../responses/financas/relatorio-entradas-saidas-cliente.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root'
})
export class RelatorioEntradasSaidasClienteService extends CommonService {
    private readonly apiUrl = `${environment.urlApiFinancas}RelatorioEntradasSaidasCliente`;

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getLookup(): Observable<RelatorioEntradasSaidasClienteLookupResponse> {
        return this.httpClient
            .get<RelatorioEntradasSaidasClienteLookupResponse>(`${this.apiUrl}/lookup`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getPreview(request: RelatorioEntradasSaidasClienteRequest): Observable<RelatorioEntradasSaidasClienteResponse> {
        return this.httpClient
            .post<RelatorioEntradasSaidasClienteResponse>(`${this.apiUrl}/preview`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public saveFavorito(request: SaveRelatorioFiltroFavoritoRequest): Observable<SaveRelatorioFiltroFavoritoResponse> {
        return this.httpClient
            .post<SaveRelatorioFiltroFavoritoResponse>(`${this.apiUrl}/favorito`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteFavorito(idRelatorioFiltroFavorito: number): Observable<ReturnStruct> {
        return this.httpClient
            .delete<ReturnStruct>(`${this.apiUrl}/favorito/${idRelatorioFiltroFavorito}`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
